
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

interface NavbarProps {
  isScrolled?: boolean;
}

export default function Navbar({ isScrolled = false }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    if (isHome) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 400);
    }
  };

  const textColor = isScrolled || !isHome ? 'text-gray-700' : 'text-white';
  const logoColor = isScrolled || !isHome ? 'text-gray-900' : 'text-white';
  const navBg = isScrolled || !isHome ? 'bg-white shadow-md' : 'bg-transparent';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link
              to="/"
              className={`text-2xl font-serif font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap ${logoColor}`}
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              K LINN Interiors
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/portfolio"
              className={`text-sm font-medium tracking-wide transition-colors hover:text-amber-600 cursor-pointer whitespace-nowrap ${textColor}`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Portfolio
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium tracking-wide transition-colors hover:text-amber-600 cursor-pointer whitespace-nowrap ${textColor}`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Services
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium tracking-wide transition-colors hover:text-amber-600 cursor-pointer whitespace-nowrap ${textColor}`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              About
            </Link>
            <Link
              to="/reviews"
              className={`text-sm font-medium tracking-wide transition-colors hover:text-amber-600 cursor-pointer whitespace-nowrap ${textColor}`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Reviews
            </Link>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-amber-600 text-white text-sm font-medium rounded-md hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Get in Touch
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-md cursor-pointer ${isScrolled || !isHome ? 'text-gray-900' : 'text-white'}`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <Link
              to="/portfolio"
              className="block text-gray-700 text-sm font-medium py-2 hover:text-amber-600 cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Portfolio
            </Link>
            <Link
              to="/services"
              className="block text-gray-700 text-sm font-medium py-2 hover:text-amber-600 cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Services
            </Link>
            <Link
              to="/about"
              className="block text-gray-700 text-sm font-medium py-2 hover:text-amber-600 cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/reviews"
              className="block text-gray-700 text-sm font-medium py-2 hover:text-amber-600 cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Reviews
            </Link>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full px-6 py-2.5 bg-amber-600 text-white text-sm font-medium rounded-md hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap text-center"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Get in Touch
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
